// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7d-3";
export var contentContainer = "_7d-0";
export var editorContainer = "_7d-1";
export var quillInputForm = "_7d-2";
export var zoneDivider = "_7d-4";